/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { type SortDirection } from '@tanstack/react-table';

import ArrowDownIcon from '@atlaskit/icon/utility/arrow-down';
import ArrowUpIcon from '@atlaskit/icon/utility/arrow-up';
import { token } from '@atlaskit/tokens';

const styles = css({
	display: 'flex',
	alignSelf: 'center',
	opacity: 1,
	transition: 'opacity 100ms ease-in-out',
});
const SortableIconClassName = 'sortable-icon';

/**
 * __SortIcon__
 *
 * SortIcon is used to display the sort state in our SortableColumn.
 */
export const SortIcon = memo(
	({
		sortDirection,
		isCurrentSort,
	}: {
		sortDirection?: false | SortDirection;
		isCurrentSort?: boolean;
	}) => {
		const primaryColor = isCurrentSort ? token('color.icon.brand') : token('color.text.disabled');

		const showSortUp = !isCurrentSort || (isCurrentSort && sortDirection === 'asc');

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<span css={styles} className={SortableIconClassName}>
				{showSortUp ? (
					<ArrowUpIcon label="ascending" color={primaryColor} spacing="compact" />
				) : (
					<ArrowDownIcon label="descending" color={primaryColor} spacing="compact" />
				)}
			</span>
		);
	},
);
